module.exports = __webpack_public_path__ + "a12b6daf7bb0c5956020d67db30b3dac.png";